import { isTDocument, TDocument } from '@modules/documents';
import type { TFile } from '@modules/files';
import type { TInlineBlock } from '@modules/inlineBlocks';
import type { TReplica } from '@modules/replicas';
import type { TPermissions } from '@modules/access/types';
import { useCanEdit } from '@modules/access/hooks/useCanEdit.hook';

export const useCanUpdateOriginalVersion = (
  item: TDocument | TFile | TInlineBlock,
  permissions: TPermissions,
  replica?: TReplica
): boolean => {
  const { canEdit } = useCanEdit(permissions.accessRight);

  return (
    !replica &&
    isTDocument(item) &&
    !item.isBlock &&
    !item.isFrozen &&
    Boolean(item.importDetails?.blobName) &&
    item.versions.length === 0 &&
    canEdit
  );
};
